package kz.dentalcrm.app.screens.main

import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.screens.main.mvi.MainSideEffect
import kz.dentalcrm.app.screens.main.mvi.MainState
import kz.dentalcrm.app.screens.main.mvi.MainViewEvent

class MainViewModel : BaseStateViewModel<MainViewEvent, MainState, MainSideEffect>() {

    override fun setInitialState() = MainState()

    override fun handleEvents(event: MainViewEvent) {
        when (event) {
            is MainViewEvent.OnTabSelected -> {
                setState {
                    copy(selectedTabIndex = event.tabIndex)
                }
            }
        }
    }
}
